import { render, staticRenderFns } from "./study-creation-date.vue?vue&type=template&id=2061ceef&"
import script from "./study-creation-date.vue?vue&type=script&lang=ts&"
export * from "./study-creation-date.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports